import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const SCHEDULED_EMAIL_TABLE_TOOLTIP_ID = 'scheduled-email-table-tooltip';

export const scheduledEmailTooltipProps = (content: string) => ({
  'data-tooltip-id': SCHEDULED_EMAIL_TABLE_TOOLTIP_ID,
  'data-tooltip-content': content,
});

export const ScheduledEmailTableTooltip: React.FC = () => (
  <ReactTooltip id={SCHEDULED_EMAIL_TABLE_TOOLTIP_ID} style={{ zIndex: 1500, maxWidth: 320 }} />
);
